import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";
import "./App.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showBackHomeModal, setShowBackHomeModal] = useState(false); // ✅ nuevo modal
  const [facturacionActiva, setFacturacionActiva] = useState(false);
  const [gestionActiva, setGestionActiva] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [CuentaCorrienteActiva, setCuentaCorrienteActiva] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const handleFacturacionClick = () => {
    setHideNav(true);
    setTimeout(() => {
      setFacturacionActiva(true);
      setGestionActiva(false);
      navigate("/tipo-comprobante");
    }, 300);
  };

  const handleCuentaCorrienteClick = () => {
    setHideNav(true);
    setTimeout(() => {
      setCuentaCorrienteActiva(true);
      setFacturacionActiva(false);
      setGestionActiva(false);
      navigate("/cuenta-corriente");
    }, 300);
  };

  const handleGestionClick = () => {
    setHideNav(true);
    setTimeout(() => {
      setGestionActiva(true);
      setFacturacionActiva(false);
      navigate("/gestionproveedoreshome");
    }, 300);
  };

  // ✅ Verifica si hay datos ingresados
  const hayProgreso = () => {
    return (
      localStorage.getItem("idRegistro") ||
      localStorage.getItem("recursosTrabajadores") ||
      localStorage.getItem("tipoComprobante")
      
    );
  };

  // ✅ Al hacer click, si hay datos -> mostrar modal
  const handleVolverHomeClick = () => {
    if (hayProgreso()) {
      setShowBackHomeModal(true);
    } else {
      volverAlHome();
    }
  };

  // ✅ Confirmación
  const volverAlHome = () => {
    setFacturacionActiva(false);
    setCuentaCorrienteActiva(false);
    setGestionActiva(false);
    setHideNav(false);
    setShowBackHomeModal(false);
    navigate("/home");
  };

  const estaActivo = facturacionActiva || CuentaCorrienteActiva || gestionActiva;

  return (
    <>
      {(showLogoutModal || showBackHomeModal) && <div className="blur-background" />}

      <div className="sidebar">
        <img src="sinec_logo_sidebar.png" alt="Logo" className="sidebar-logo" />

        {!estaActivo && (
          <nav className={`sidebar-nav ${hideNav ? "fade-out" : "fade-in"}`}>
            <button className={`sidebar-button ${facturacionActiva ? "active" : ""}`} onClick={handleFacturacionClick}>
              Facturación
            </button>
            <button className={`sidebar-button ${CuentaCorrienteActiva ? "active" : ""}`} onClick={handleCuentaCorrienteClick}>
              Cuenta Corriente
            </button>
            <button className={`sidebar-button ${gestionActiva ? "active" : ""}`} onClick={handleGestionClick}>
              Gestión Proveedores
            </button>
          </nav>
        )}

        {facturacionActiva && (
          <nav className="sidebar-nav fade-in">
            <button className="sidebar-button active">Facturación</button>
            <button className="sidebar-button return-button" onClick={handleVolverHomeClick}>
              ← Volver al Home
            </button>
          </nav>
        )}

        {CuentaCorrienteActiva && (
          <nav className="sidebar-nav fade-in">
            <button className="sidebar-button active">Cuenta Corriente</button>
            <button className="sidebar-button return-button" onClick={handleVolverHomeClick}>
              ← Volver al Home
            </button>
          </nav>
        )}

        {gestionActiva && (
          <nav className="sidebar-nav fade-in">
            <button className="sidebar-button active">Gestión Proveedores</button>
            <button className="sidebar-button return-button" onClick={handleVolverHomeClick}>
              ← Volver al Home
            </button>
          </nav>
        )}

        <button className="logout-button" onClick={() => setShowLogoutModal(true)}>
          Cerrar Sesión
        </button>

        <div className="sidebar-footer">
          <img src="./logo-sistemas.png" alt="Sistemas" className="sidebar-footer-logo" />
          <span className="sidebar-footer-text">Sistemas Inteligentes</span>
        </div>
      </div>

      {/* ✅ Modal de cierre de sesión */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">❗️</div>
            <p>¿Estás seguro que deseas cerrar sesión?</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={handleLogout}>Sí</button>
              <button className="no-btn" onClick={() => setShowLogoutModal(false)}>No</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Modal de confirmación para volver al home */}
      {showBackHomeModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Deseás volver al Home? Se perderán los datos ingresados.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={volverAlHome}>Sí, volver</button>
              <button className="no-btn" onClick={() => setShowBackHomeModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;






